"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Ref } from "vue-property-decorator";
import _ from "lodash";
import { AddRulesController } from "@/views/managements/safemanager/AddRulesPage.vue";
import AddNewWebPageByHandDialog from "@/views/managements/safemanager/dialogs/AddNewWebPageByHand.vue";
import SelectHasWebPageDialog from "@/views/managements/safemanager/dialogs/SelectHasWebPageDialog.vue";
import GroupManageDialog from "@/views/safemanagements/WebResourceManager/components/webResourceDialogs/GroupManagerDialog.vue";
import API from "@ym-framework/api-utils";
import WebPageRulesSettingDialog from "@/views/managements/safemanager/rulespage/WebPageRulesSettingDialog.vue";
const emptyImage = require("@/assets/img/safety-empty/security-list-null.png");
let AddRulesRightPage = class extends Vue {
  constructor() {
    super(...arguments);
    this.selectedDatas = [];
    this.expands = [];
    this.empty_image = emptyImage;
    this.scope_choices = [
      { label: this.$t("add_rules.form.rules_scope_all"), value: "all" },
      { label: this.$t("add_rules.form.rules_scope_part"), value: "web" }
    ];
    this.choice_list = [
      { label: this.$t("add_rules.form.choice_list_1"), value: "ALLOW" },
      {
        label: this.$t("add_rules.form.choice_list_2"),
        value: "ALLOW_AND_RECORD"
      },
      {
        label: this.$t("add_rules.form.choice_list_3"),
        value: "RESTRICTION_AND_RECORD"
      }
    ];
    this.choice_password_list = [
      { label: this.$t("add_rules.form.choice_list_1"), value: "ALLOW" },
      { label: this.$t("add_rules.form.choice_list_4"), value: "RESTRICTION" }
    ];
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  addHasResource() {
    return __async(this, null, function* () {
      if (this.selectedDatas.length > 0) {
        this._has_web_page_dialog.open(this.selectedDatas);
      } else {
        this._has_web_page_dialog.open();
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      if (this.selectedDatas.length > 0) {
        yield this._has_web_page_dialog.refresh(this.selectedDatas);
      } else {
        yield this._has_web_page_dialog.refresh();
      }
    });
  }
  //手动添加网页资源成功并增加当前选中网页内容
  addByHandSuccess(id) {
    return __async(this, null, function* () {
      try {
        const search_response = yield API.get(
          `api://base.auth/api/v1/web-resources`,
          {
            params: {
              page: 1,
              size: 100,
              search: `id==${id}`
            }
          }
        );
        let searchData = search_response.data.result.datas[0];
        let injectItem = {
          id: searchData.id,
          description: searchData.description,
          model: searchData.model,
          name: searchData.name,
          type: searchData.type,
          url: searchData.url,
          xpathNum: searchData.xpathNum,
          group: searchData.group,
          rulesAccess: true,
          recordAccess: true,
          accessRules: [
            //复制
            {
              code: "duplicate",
              power: "ALLOW_AND_RECORD"
            },
            //文件上传
            {
              code: "file_upload",
              power: "ALLOW_AND_RECORD"
            },
            //文件下载
            {
              code: "file_download",
              power: "ALLOW_AND_RECORD"
            },
            //打印
            {
              code: "print",
              power: "ALLOW_AND_RECORD"
            }
          ],
          selectedElementIds: []
        };
        let selectedItem = _.find(
          this._formController.webpageResourceAccessRules,
          {
            id: searchData.group.id
          }
        );
        if (selectedItem !== void 0) {
          selectedItem.arr.push(injectItem);
        } else {
          let arr = [];
          arr.push(injectItem);
          let data = {
            name: injectItem.group.parent.name + "-" + injectItem.group.name,
            id: injectItem.group.id,
            arr
          };
          this.selectedDatas.push(injectItem);
          this._formController.webpageResourceAccessRules.push(data);
          this.expands.push(injectItem.group.id);
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  //为编辑模式注入选中的值
  setSelectedDatas(datas) {
    this.selectedDatas = datas;
  }
  //处理选中的网页内容
  selectedWebPages(datas) {
    return __async(this, null, function* () {
      var _a;
      this.selectedDatas = datas;
      let arrData = [];
      for (let item of this.selectedDatas) {
        if (_.find(arrData, { id: item.group.id }) !== void 0) {
          continue;
        }
        let arr = [];
        let name = item.group.parent.name + "-" + item.group.name;
        let group_id = item.group.id;
        for (let selectitem of this.selectedDatas) {
          if (selectitem.group.id === group_id) {
            let rule_item = {
              id: selectitem.id,
              description: selectitem.description,
              model: selectitem.model,
              name: selectitem.name,
              type: selectitem.type,
              url: selectitem.url,
              xpathNum: selectitem.xpathNum,
              group: selectitem.group,
              rulesAccess: selectitem.rulesAccess === void 0 ? true : selectitem.rulesAccess,
              recordAccess: selectitem.recordAccess === void 0 ? true : selectitem.recordAccess,
              accessRules: [
                //复制
                {
                  code: "duplicate",
                  power: "ALLOW_AND_RECORD"
                },
                //文件上传
                {
                  code: "file_upload",
                  power: "ALLOW_AND_RECORD"
                },
                //文件下载
                {
                  code: "file_download",
                  power: "ALLOW_AND_RECORD"
                },
                //打印
                {
                  code: "print",
                  power: "ALLOW_AND_RECORD"
                }
              ],
              selectedElementIds: (_a = selectitem.selectedElementIds) != null ? _a : []
            };
            arr.push(rule_item);
          }
        }
        let data = {
          name,
          id: group_id,
          arr
        };
        this.expands.push(group_id);
        arrData.push(data);
      }
      this._formController.webpageResourceAccessRules = arrData;
    });
  }
  clickExpendColumn(row, column, event) {
    if (this.expands.includes(row.id)) {
      this.expands = this.expands.filter((val) => {
        return val !== row.id;
      });
    } else {
      this.expands.push(row.id);
    }
  }
  openGroupDialog() {
    this._group_manage_dialog.open();
  }
  deleteColumn(row) {
    for (let i = 0; i < this._formController.webpageResourceAccessRules.length; i++) {
      if (this._formController.webpageResourceAccessRules[i].id === row.id) {
        this._formController.webpageResourceAccessRules.splice(i, 1);
      }
    }
    for (const item of row.arr) {
      this.selectedDatas = _.filter(this.selectedDatas, (data) => {
        return data.id !== item.id;
      });
    }
  }
  deleteRules(row, group_row) {
    if (group_row.arr.length === 1) {
      for (let i = 0; i < this._formController.webpageResourceAccessRules.length; i++) {
        if (this._formController.webpageResourceAccessRules[i].id === group_row.id) {
          this._formController.webpageResourceAccessRules.splice(i, 1);
        }
      }
      this.selectedDatas = _.filter(this.selectedDatas, (data) => {
        return data.id !== group_row.id;
      });
    } else {
      for (let i = 0; i < group_row.arr.length; i++) {
        if (group_row.arr[i].id === row.id) {
          group_row.arr.splice(i, 1);
        }
      }
      this.selectedDatas = _.filter(this.selectedDatas, (data) => {
        return data.id !== row.id;
      });
    }
  }
  selectedRulesSettings(data) {
    return __async(this, null, function* () {
      let group_row = _.find(this._formController.webpageResourceAccessRules, {
        id: data.item.group.id
      });
      if (group_row !== void 0) {
        for (let i = 0; i < group_row.arr.length; i++) {
          if (group_row.arr[i].id === data.item.id) {
            group_row.arr[i] = data.item;
          }
        }
      }
      let item = _.find(this.selectedDatas, { id: data.item.id });
      item = data;
    });
  }
  openWebRulesSetting(row) {
    return __async(this, null, function* () {
      this._web_page_rules_setting_dialog.open(row);
    });
  }
  addNewWebPage() {
    return __async(this, null, function* () {
      this._addNewWebPageByHandDialog.open();
    });
  }
};
__decorateClass([
  PropSync("formController", {
    type: Object,
    default: () => new AddRulesController()
  })
], AddRulesRightPage.prototype, "_formController", 2);
__decorateClass([
  PropSync("editMode", {
    type: Boolean,
    default: () => false
  })
], AddRulesRightPage.prototype, "_editMode", 2);
__decorateClass([
  Ref("addNewWebPageByHandDialog")
], AddRulesRightPage.prototype, "_addNewWebPageByHandDialog", 2);
__decorateClass([
  Ref("hasWebPageDialog")
], AddRulesRightPage.prototype, "_has_web_page_dialog", 2);
__decorateClass([
  Ref("webPageRulesSettingDialog")
], AddRulesRightPage.prototype, "_web_page_rules_setting_dialog", 2);
__decorateClass([
  Ref("groupManageDialog")
], AddRulesRightPage.prototype, "_group_manage_dialog", 2);
AddRulesRightPage = __decorateClass([
  Component({
    components: {
      AddNewWebPageByHandDialog,
      SelectHasWebPageDialog,
      WebPageRulesSettingDialog,
      GroupManageDialog
    }
  })
], AddRulesRightPage);
export {
  AddRulesRightPage as default
};
